
export const Action_GetCauHinhJS = "Action_GetCauHinhJS";
export const Action_GetCauHinhJSSuccess = "Action_GetCauHinhJSSuccess";


export const Action_SaveLichSuView = "Action_SaveLichSuView";
export const Action_SaveLichSuViewSuccess = "AAction_SaveLichSuViewSuccess";

export const Action_GetLichSuView = "Action_GetLichSuView";
export const Action_GetLichSuViewSuccess = "Action_GetLichSuViewSuccess";

